var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":_vm.label,"items":_vm.items,"hide-details":_vm.shouldHideDetails,"value":_vm.data},on:{"change":function($event){return _vm.$emit('change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }